import React from 'react';
import { Typography, Box, Stack } from '@mui/material';
import HorizontalScrollbarExercise from './HorizontalScrollbarExercise';
import Loader from './Loader';

const SimilarExercises = ({ targetMuscleExercises }) => (
  <Box sx={{ mt: { lg: '100px', xs: '20px', s: '20px' } }}>
    <Typography sx={{ fontFamily: 'GveretLevin', fontSize: { lg: '44px', xs: '25px' }, direction: 'rtl', textAlign: 'center', ml: '20px', mr: "10px" }} fontWeight={700} color="#000" mb="33px">
      תרגילים דומים <span style={{ color: '#B5A78A', textTransform: 'capitalize' }}>לאותו השריר</span>
    </Typography>
    <Stack direction="row" sx={{ p: 2, position: 'relative' }}>
      {targetMuscleExercises.length !== 0 ? <HorizontalScrollbarExercise data={targetMuscleExercises} /> : <Loader />}
    </Stack>
  </Box>
);

export default SimilarExercises;